"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28017],{

/***/ 28017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgCoinsFilled = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 64,
  height: 64,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#FFE603"
})), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M29.401 23.286a1 1 0 1 0 1.4 1.428l-1.4-1.428Zm9.885 9.913a1 1 0 0 0 1.428 1.4l-1.428-1.4Zm-12.34-1.031a1 1 0 0 0 1.109 1.664l-1.11-1.664ZM29 32h1a1 1 0 0 0-1.555-.832L29 32Zm-1 5.5a1 1 0 1 0 2 0h-2Zm-.5-1a1 1 0 1 0 0 2v-2Zm3 2a1 1 0 1 0 0-2v2ZM43 29a8 8 0 0 0-8-8v2a6 6 0 0 1 6 6h2Zm-8-8c-2.18 0-4.157.873-5.599 2.286l1.4 1.428A5.977 5.977 0 0 1 35 23v-2Zm5.714 13.599A7.978 7.978 0 0 0 43 29h-2a5.977 5.977 0 0 1-1.714 4.2l1.428 1.399ZM35 35a6 6 0 0 1-6 6v2a8 8 0 0 0 8-8h-2Zm-6 6a6 6 0 0 1-6-6h-2a8 8 0 0 0 8 8v-2Zm-6-6a6 6 0 0 1 6-6v-2a8 8 0 0 0-8 8h2Zm6-6a6 6 0 0 1 6 6h2a8 8 0 0 0-8-8v2Zm-.945 4.832 1.5-1-1.11-1.664-1.5 1 1.11 1.664ZM28 32v5.5h2V32h-2Zm-.5 6.5h3v-2h-3v2Z",
  fill: "#171717"
})));
/* harmony default export */ __webpack_exports__["default"] = (SvgCoinsFilled);

/***/ })

}]);